module.exports = require("@splunk/react-visualizations/MarkerGauge");